export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    align: 'center',
    fixed: 'right',
    width: 90,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_displayLogo') || 'LOGO',
    field: 'displayLogo',
    width: 110,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayLogo' },
  },
  {
    title: that.$l('table_label_displayNo') || '客户编号',
    field: 'displayNo',
    width: 125,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_displayName') || '客户名称',
    field: 'displayName',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displayUser') || '团队成员',
    field: 'displayUser',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayUser' },
  },
  {
    title: that.$l('table_label_bizTeamRoles') || '团队角色',
    field: 'v_bizTeamRoles',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCategory') || '负责客户品类',
    field: 'displayCategory',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCategory' },
  },
  {
    title: that.$l('table_label_userResponsibilities') || '职责说明',
    field: 'userResponsibilities',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayStatus') || '有效状态',
    field: 'displayStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayStatus' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
